import {
  OurIngredientsRoot,
  OurIngredientsSection,
  BenefitsWrapper,
  IngredientsWrapper,
  BenefitsList,
  MobileList,
  InfoWrapper,
  SliderContainer,
  SectionTitle,
  IngredientsCard,
  CardImage,
  CardText,
  BorderWrapper,
} from './OurIngredients.styles'
import { ColorTokens } from 'stitches.config'
import { useTranslation } from 'hooks/useTranslation'
import { Text } from 'components/Text'
import Trans from 'next-translate/Trans'
import { Stack } from 'components/Stack'
import { InformationCollapse, InformationCollapseType } from 'components/InformationCollapse'
import Slider from 'react-slick'
import Image, { StaticImageData} from 'next/image'
import { sliderSettings } from 'fixtures/slider'
import { Icon } from 'components/Icon'
import { BorderWave } from 'components/BorderWave'
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { Proteins } from 'models/Pet'
import { TranslationKeys } from 'locales/translationKeys'

type OurIngredientsProps = {
  background: ColorTokens
  recipe: Proteins.BEEF | Proteins.LAMB | Proteins.TURKEY
  ingredients: IngredientType[]
}

export type IngredientType = {
  label: TranslationKeys
  info: TranslationKeys
  src: StaticImageData
  icon: any
}

export const OurIngredients = ({ background, recipe, ingredients }: OurIngredientsProps) => {
  const { t } = useTranslation()

  const infoList: InformationCollapseType[] = [
    {
      label: `recipes:${recipe}.hero.ingredients.label`,
      description: `recipes:${recipe}.hero.ingredients.description`,
    },
    {
      label: `recipes:${recipe}.hero.nutrition.label`,
      description: `recipes:${recipe}.hero.nutrition.description`,
    },
  ]

  function RightArrow(props: any) {
    const { className, style, onClick } = props
    return (
      <Icon
        color="accent-black"
        size="8"
        name="angle-right"
        className={className}
        style={{ ...style, display: 'block' }}
        onClick={onClick}
      />
    )
  }

  function LeftArrow(props: any) {
    const { className, style, onClick } = props
    return (
      <Icon
        color="accent-black"
        size="8"
        name="angle-left"
        className={className}
        style={{ ...style, display: 'block' }}
        onClick={onClick}
      />
    )
  }

  const sliderSettingsIngredients = {
    ...sliderSettings,
    dots: true,
    arrows: true,
    nextArrow: <RightArrow />,
    prevArrow: <LeftArrow />,
  }

  return (
    <>
      <OurIngredientsRoot
        css={{
          background: `$${background}`,
        }}
      >
        <OurIngredientsSection>
          <BenefitsWrapper>
            <Stack
              gap={{ '@initial': '1', '@bp3': '2' }}
              direction="column"
              alignItems={{ '@initial': 'center', '@bp3': 'flex-start' }}
            >
              <SectionTitle>{t(`products:essentials.ourIngredients.${recipe}`)}</SectionTitle>
              <Text
                color="accent-black"
                weight="semiBold"
                size='bodyExtraLarge'
              >
                {t('products:essentials.ourIngredients.benefits')}
              </Text>
            </Stack>
            <BenefitsList>
              <Trans
                i18nKey={`recipes:${recipe}.benefits.description`}
                components={{ ul: <ul />, li: <li /> }}
              />
            </BenefitsList>
            <MobileList>
              <Trans
                i18nKey={`recipes:${recipe}.benefits.description-m`}
                components={{ br: <br /> }}
              />
            </MobileList>
            <InfoWrapper>
              <InformationCollapse infoList={infoList} />
            </InfoWrapper>
          </BenefitsWrapper>
          <IngredientsWrapper>
            <SectionTitle center>
              {t(`products:essentials.ourIngredients.ourIngredients`)}
            </SectionTitle>
            <SliderContainer>
              <Slider {...sliderSettingsIngredients}>
                {ingredients.map((ingredient, index) => (
                  <IngredientsCard key={index}>
                    <CardImage>
                      <Image priority={true} src={ingredient.src} alt={ingredient.label} />
                    </CardImage>
                    <CardText>
                      <Text align="center" size="bodyExtraLarge" weight="semiBold" color="primary-500">
                        {t(`${ingredient.label}`)}
                      </Text>
                      <Text align="center" size={{'@initial': 'body', '@bp3': 'bodyLarge'}} color="accent-black">
                        {t(`${ingredient.info}`)}
                      </Text>
                    </CardText>
                  </IngredientsCard>
                ))}
              </Slider>
            </SliderContainer>
          </IngredientsWrapper>
        </OurIngredientsSection>
      </OurIngredientsRoot>
      <BorderWrapper recipe={recipe}>
        <BorderWave
          background={background}
          svgHeight="78px"
          invert
          svgWidth="calc(144% + 1.3px)"
          path="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
        />
      </BorderWrapper>
    </>
  )
}
